module.exports = __webpack_public_path__ + "assets/media/8.85301bff.wav";